var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',[(_vm.nodetype == 'usecase')?_c('div',[_c('Page_Usecase',{attrs:{"node":_vm.node}})],1):_vm._e(),(_vm.nodetype == 'field')?_c('div',[_c('Page_Testfield',{attrs:{"node":_vm.node}})],1):_vm._e(),(_vm.nodetype == 'device')?_c('div',[_c('Page_Device',{attrs:{"node":_vm.node}})],1):_vm._e()]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }